import getConfig from 'next/config'

const { publicRuntimeConfig } = getConfig()

export const LIVEKIT_SERVER_URL = 'wss://teleatendimento-hu799eww.livekit.cloud'

export const APP_KEY = publicRuntimeConfig?.APP_KEY
export const INSTITUTION_SLUG = publicRuntimeConfig?.INSTITUTION_SLUG
export const INSTITUTION_API_URL = publicRuntimeConfig?.INSTITUTION_API_URL
export const INSTITUTION_WEB_SOCKET_URL = publicRuntimeConfig?.INSTITUTION_API_URL
export const INSTITUTION_MODULES = publicRuntimeConfig?.INSTITUTION_MODULES
  ? JSON.parse(publicRuntimeConfig?.INSTITUTION_MODULES as string)
  : {}
